interface ProfilePaths {
    base: string;
    about: string;
}

export const profilePaths = (designerId: string, jobId?: string): ProfilePaths => {
    const base = `/profiles/${designerId}`;
    const param = jobId ? `?jobId=${jobId}` : '';

    return {
        base: `${base}${param}`,
        about: `${base}/about${param}`,
    };
};
